import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { FAQ, Home, Notice, Ticket } from './routes/Page';
import Privacy from './routes/Privacy';
import PrivacyEn from './routes/PrivacyEn';
import Terms from './routes/Terms';
import TermsEn from './routes/TermsEn';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/terms/en" element={<TermsEn />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/privacy/en" element={<PrivacyEn />} />
        <Route path="/notices/en/:id" element={<Notice locale="en" />} />
        <Route path="/notices/:id" element={<Notice />} />
        <Route path="/faqs/en/:id" element={<FAQ locale="en" />} />
        <Route path="/faqs/:id" element={<FAQ />} />
        <Route path="/tickets/:id" element={<Ticket />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
